import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import forEach from 'lodash/forEach';

import { ID } from '../../../../../types';

import { UniversalFilterSavedState } from '../../utils/UniversalFilterSavedState';

function useUniversalFilterClearFieldsSavedState() {
  const queryClient = useQueryClient();

  const handleUniversalFilterClearFieldsSavedState = useCallback<
    (options: { viewId: ID; fieldNames: string[] }) => void
  >(
    ({ viewId, fieldNames }) => {
      forEach(fieldNames, (fieldName) => {
        const cacheKey = UniversalFilterSavedState.getCacheKey({
          viewId,
          fieldName
        });
        queryClient.setQueryData(cacheKey, null);
      });
    },
    [queryClient]
  );

  return { handleUniversalFilterClearFieldsSavedState };
}

export default useUniversalFilterClearFieldsSavedState;
